import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesCreditSetupComponent} from "./sales-credit-setup.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";



@NgModule({
  declarations: [
    SalesCreditSetupComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule

  ],
  exports: [
    SalesCreditSetupComponent
  ]
})
export class SalesCreditSetupModule { }
